import { ProductType } from '@yme/common/constants';
import { MAX_ADDRESS_LENGTH, SHIPMENT_LABEL_DEFAULT_VALUE, SHIPMENT_LABEL_MAX_LENGTH, } from './constants';
export const getMaxLengthStringValue = (value) => value ? value.substring(0, MAX_ADDRESS_LENGTH) : '';
export const getShippingAddressCountry = (internalCountryFieldEnabled, shippingCountry, isHomeDelivery, currentCountryRoot, dealerCountry = '') => {
    if (internalCountryFieldEnabled) {
        return isHomeDelivery ? shippingCountry : dealerCountry;
    }
    return isHomeDelivery ? currentCountryRoot.toUpperCase() : dealerCountry;
};
export const getIsGuestFlagValue = (cart, profileData) => {
    const userId = profileData.data?.customAttributes?.myYamahaUserId || '';
    const hasUserId = userId.length > 0;
    let isGuestCart = true;
    if (cart.data?.isGuestCart === false) {
        isGuestCart = false;
    }
    const hasUnitInCart = cart.data?.entries.some((item) => item.productType === ProductType.UNIT);
    if (hasUnitInCart) {
        isGuestCart = false; // always false for unit cart
    }
    else {
        if (isGuestCart && hasUserId) {
            isGuestCart = false;
        }
    }
    return isGuestCart;
};
export const getShipmentLabel = ({ firstName, lastName, }) => {
    const shipmentLabelFullName = `${firstName} ${lastName}`.trim();
    const shipmentLabelCutName = `${firstName[0] || ''} ${lastName}`.trim();
    const shipmentLabel = shipmentLabelFullName.length > SHIPMENT_LABEL_MAX_LENGTH
        ? shipmentLabelCutName
        : shipmentLabelFullName;
    return shipmentLabel.length ? shipmentLabel : SHIPMENT_LABEL_DEFAULT_VALUE;
};
